import { render, staticRenderFns } from "./FilterElement.vue?vue&type=template&id=2cb676b0&scoped=true&"
import script from "./FilterElement.vue?vue&type=script&lang=js&"
export * from "./FilterElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb676b0",
  null
  
)

export default component.exports